import React from 'react';
import '../../../styles/site.css';
import bannerImage from '../../../img/banner.png';
import csBannerImage from '../../../img/imgCS.png';

const Banner = () => {
    return (
        <div className="row row-banner">
            {/* <div className="col-sm-2 sinPadding">
                <img src="https://csintercelulas.s3.amazonaws.com/code/media/csbanner.png" className="img-responsive cs-banner" alt="" />
                <img src="https://appsd.compusoluciones.com/csEstilos/csImagenes/imgCS.png" className="img-responsive cs-banner" alt="" />
            </div> */}
            <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
                <div className="col-sm-2 col-banner">
                    {/* <img src="https://csintercelulas.s3.amazonaws.com/code/media/febanner.png" className="img-responsive fe-banner" alt="" /> */}
                    <img src={csBannerImage} className="img-responsive fe-banner" alt="" />

                </div>
                <div className="col-sm-10 col-banner">
                    {/* <img src="https://csintercelulas.s3.amazonaws.com/code/media/febanner.png" className="img-responsive fe-banner" alt="" /> */}
                    <img src={bannerImage} className="img-responsive fe-banner" alt="" />

                </div>

            </div>
        </div>
    )
}
/* retorna true si al pasar los nextProps a renderizar retorna el mismo resultado que al pasar los prevProps a renderizar, de otro modo retorna false */
function validaProps(prevProps, nextProps) {
    //si retorna un falso renderiza todo el componente, porque si es falso significa que el valor cambio
    //falso es igual que son diferentes
    //si son muchos objetos va si [0]
    return (prevProps.start === nextProps.start);
}

export default React.memo(Banner, validaProps);
